import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { TenantListPage } from '@/components/tenant-list-page'

export const Route = createFileRoute('/_app/tenants/upcoming')({
	component: TenantUpcomingPage,
})

function TenantUpcomingPage() {
	const { t } = useTranslation()
	return (
		<TenantListPage
			period="upcoming"
			emptyTitle={t('tenants.upcoming.emptyTitle')}
			emptyDescription={t('tenants.upcoming.emptyDescription')}
		/>
	)
}
